import { Lookup } from "./lookup";

export class RemoteAnswer {
    id:string;
    name:string;
    description:string;
    assessment:Lookup;
    assessmentChecklist:Lookup;
    remoteQuestion:Lookup;
    hasFiles:boolean;
    textAnswer:string;
    textDescription:string;
    resourcesLinks:string;
    fileNames:string[];
}


export class ProfessionalServicesResponse {
    result:boolean;
    message:string;
    isAssessmentStartDateContain:boolean;
    remoteAnswers:RemoteAnswer[]
}